export default __webpack_public_path__ + "static/media/whats.0f78ac85.svg";